import React, { useEffect } from 'react';

const useProfile = () => {
  const [profile, setProfile] = React.useState(null);

  useEffect(() => {
    const userProfile = JSON.parse(sessionStorage.getItem('profile'));
    setProfile(userProfile);
  }, []);

  return { isAdmin: profile?.super === 1, profile };
};

export default useProfile;
